var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1168,
    height: 318,
    viewBox: "0 0 1168 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800049,
    width: 1166.4,
    height: 318,
    rx: 20,
    fill: "#198754"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36_63",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1168,
    height: 318
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.800049,
    width: 1166.4,
    height: 318,
    rx: 20,
    fill: "#FD7E14"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36_63)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-31.238 -216.961C25.7831 -250.947 91.423 -236.228 115.876 -185.578C140.328 -134.928 115.059 -66.0254 58.0381 -32.0395C1.01703 1.94646 -64.6228 -12.7725 -89.0755 -63.4221C-113.528 -114.072 -88.2591 -182.975 -31.238 -216.961Z",
    fill: "#198754",
    stroke: "#F1F5F9",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.3 300.5C1224.76 300.5 1278.9 350.482 1278.9 411.5C1278.9 472.518 1224.76 522.5 1157.3 522.5C1089.84 522.5 1035.7 472.518 1035.7 411.5C1035.7 350.482 1089.84 300.5 1157.3 300.5Z",
    fill: "#198754",
    stroke: "white",
    strokeWidth: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/Newsletter.c9793da9e266b1c3332dfb90e7188965.svg";
export { ForwardRef as ReactComponent };